export const environment = {
  production: false,
  //  serverIP:'https://faysalfunds-api.lfdanalytics.com/',
  serverIP: 'https://askariportal-devapi.lfdanalytics.com/',
};